import { Alert } from '../../../models/alert.model';

export class UpdateNewAlerts {

    static readonly type = '[ALERT] update new alerts';

    constructor(public payload: Array<Alert>) { }

}
